import { IWoocommerceProduct } from 'interfaces';
import { createSelector } from 'reselect';
import { findVariationForProductSelection } from 'utils/product-variation';
import { getDefaultColorOption, getDefaultLineLengthOption, getDefaultSizeOption } from 'helpers/productDetails';


export const selectedProductsWithVariations = createSelector([
  (state) => state.calculator.chosenProducts,
], (chosenProducts) => {
  if(chosenProducts == null)
    return [];
  
  return chosenProducts.map((element: IWoocommerceProduct) => {
    const productVariations = element.productVariations && Object.values(element.productVariations);
    if (productVariations == null)
      return element;

    const productWithDefaults = {
      ...element,
      selectedSize: getDefaultSizeOption(element, productVariations.find(variation => variation.size)?.size ?? ''),
      selectedColor: getDefaultColorOption(element, productVariations.find(variation => variation.color)?.color ?? ''),
      selectedLineLength: getDefaultLineLengthOption(element, productVariations.find(variation => variation.lineLength)?.lineLength ?? ''),
    };

    const foundProductVariation = findVariationForProductSelection(productVariations, productWithDefaults);
    if(foundProductVariation == null)
      return productWithDefaults;

    return Object.keys(foundProductVariation).length === 0 ? 
      productWithDefaults
      :
      {
        ...productWithDefaults,
        selectedProductVariation: foundProductVariation
      } as IWoocommerceProduct;
  });
});

export const chosenProducts = createSelector([
  (state) => state.calculator.chosenProducts
], chosenProducts => chosenProducts);

export const currentFee = createSelector([
  (state) => state.calculator.currentFee
], currentFee => currentFee);

export const currentMonthsSelection = createSelector([
  (state) => state.calculator.currentMonthsSelection
], currentMonthsSelection => currentMonthsSelection);
